import { createSelector } from 'reselect';
import { getProductionScheduleEnabled } from './getProductionScheduleEnabled';

const getSelectWorkOrderOp = (state) => {
  return state.selectWorkOrderOp;
};

export const getSelectWorkOrderOpOpen = (state) => {
  return state.selectWorkOrderOp.open;
};

export const getSelectWorkOrderOpOptions = createSelector(
  [getSelectWorkOrderOp, getProductionScheduleEnabled],
  ({ options }, productionScheduleEnabled) => {
    const { isSearchMode, onlyMachineChecked, search, nextStep } = options;
    const onlyMachineCheckedDisabled =
      !isSearchMode && !productionScheduleEnabled;

    return {
      ...options,
      isSearchMode,
      onlyMachineChecked: onlyMachineCheckedDisabled
        ? false
        : onlyMachineChecked,
      search: isSearchMode ? search : '',
      nextStep,
    };
  }
);
